import { createSelector } from 'reselect'

const getSignupData = state => state.signup
const getUserData = state => state.user

const sendEmailForm = createSelector(
	[ getSignupData, getUserData ],
	(signupData, userData) => ({
		referral: signupData.referral,
		userId: userData.data.userId,
		presenterUid: userData.data.presenterUid || '',
	})
)

export default sendEmailForm
